import { useState, useEffect, useRef } from 'react'

interface UseDebounceOptions {
    ignoreInitialUpdate?: boolean
}

function useSkipbounce<T>(value: T, refractoryPeriodMs: number, options?: UseDebounceOptions) {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = useState(value)
    // const firstUpdate = useRef(options?.ignoreInitialUpdate || false)

    const isInRefractoryPeriodRef = useRef(false)

    useEffect(() => {
        // if (firstUpdate.current) {
        //     firstUpdate.current = false
        //     return
        // }

        if (!isInRefractoryPeriodRef.current) {
            setDebouncedValue(value)
            // Enter refractory period & timer to set it off.
            if (value) {
                // only if rising edge
                isInRefractoryPeriodRef.current = true
                setTimeout(() => {
                    isInRefractoryPeriodRef.current = false
                }, refractoryPeriodMs)
            }
        } else {
            // If we are in the refractory period, then we only allow the falling edge (the 'false' value)
            if (!value) {
                setDebouncedValue(value)
            }
        }

        return () => {}
    }, [value])

    return debouncedValue
}

export default useSkipbounce
